import _ from 'underscore';
import { CampaignuiBaseColumn } from '@bingads-webui-campaign/campaignui-base-column';
import { SchemaI18n } from '@bingads-webui-universal/schema-i18n';
import { BidStrategyTypeColumn as BidStrategyTypeColumnConfig } from '@bingads-webui-campaign/ad-groups-data';
import { isXandrServing } from '@bingads-webui-campaign-react/constants';

import bidStrategyTypeTemplate from './bid-strategy-type.pug';

export class BidStrategyTypeColumn extends CampaignuiBaseColumn {
  constructor({ i18n }) {
    const title = i18n.getString('ColumnName_BidStrategyType');

    super({
      ...BidStrategyTypeColumnConfig,
      title,
      sortable: 'DisplayBiddingStrategyType',
      type: 'string',
      helpId: 'pop_BA_CampaignGrids_BidStrategy',
      helpAriaLabel: i18n.getString('Click to learn more about {{item}}', { item: title }),
    });
    this.schemaI18n = new SchemaI18n({ i18n });
  }

  pickProperty(item) {
    let type = item.DisplayBiddingStrategyType;

    if (isXandrServing(_.result(item.Campaign, 'CampaignSubType'), _.result(item.Campaign, 'CampaignSettings'))) {
      if (type === 'ManualCpm') {
        type = 'ViewableCpm';
      } else if (type === 'ManualCpv') {
        type = 'Cpcv';
      }
    }

    return type;
  }

  template({ value }) {
    return bidStrategyTypeTemplate({ value, schemaI18n: this.schemaI18n });
  }
}
